import { useState, useEffect } from "react";
import useWindowSize from "../../../hooks/useWindowSize";
import Modal from "../../../ReusableComponents/Modal";
import Form from "../../../ReusableComponents/Form";
import InputField from "../../../ReusableComponents/InputField";
import dateFormat from "dateformat";
import {
  addressValidation,
  campAddressValidation,
  campaignMaxLimitValidation,
  campaignNameValidation,
  emailValidation,
  nameValidation,
  phoneNumValidation,
} from "../../../utils/inputValidations";
import { Button } from "../../../Components/Helper";
import SelectField from "../../../ReusableComponents/SelectField";
import { selectFieldValidation } from "../../../utils/inputValidations";
import { set } from "lodash";
import { useNavigate } from "react-router";
import Popup from "../../../ReusableFunctions/Popup";
import { useSelector } from "react-redux";
import {
  CreateCrmleads,
  getCrmleadsInsight,
  updateCrmleads,
} from "../../../apis/BhuMeetTeams/Crm/leads";
import { getDistricts, getStates, getTalukas } from "../../../apis/locations";
import MultiSelectField from "../../../ReusableComponents/MultiSelectField";
import {
  createCampaign,
  getTelecallerTeams,
  getTelecallerTeamswithCount,
} from "../../../apis/adminAPIs/teams";
import Loading from "../../../ReusableFunctions/Loader";
import TableView from "../../../ReusableComponents/TableView/TableView";
import DateTimePicker from "../../../ReusableComponents/DateTimePicker";

const formatToIST = (dateObj) => {
  // Ensure we are dealing with a valid Date object
  const date = new Date(dateObj);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:00`;
};


export const CreateCampaign = ({ open, onClose, existingCampaign }) => {
  const { currentHeight, currentWidth } = useWindowSize();


  const [campaignName, setCampaignName] = useState("");

  const [indianStates, setIndianStates] = useState([]);
  const [StateDistrict, setStateDistrict] = useState([]);
  const [DistrictsLoading, setDistrictsLoading] = useState(false);
  const [StatesLoading, setStatesLoading] = useState(false);
  const [talukas, setTalukas] = useState([]);
  const [talukasLoading, setTalukasLoading] = useState(false);
  const [telecallerDeskCallers, setTelecallerDeskCallers] = useState([]);
  const [stateInsight, setstateInsight] = useState(null)
  const [campType, setCampType] = useState("");

  useEffect(() => {
    getStatesFunc();
    getAllTeleCaller();

  }, []);

  const [CreateLeadForm, setCreateLeadForm] = useState({
    name: "",
    assignee: [],
    target: "",
    source: "",
    type: "",
    taluka: "",
    district: "",
    state: "",
    address: "",
    maxLimit: "",
    Existing: true,
    excludeCampaign: [],
    scheduleTime: new Date().toISOString()
  });


  const [rawAddress, setRawAddress] = useState("");
  const [debouncedAddress, setDebouncedAddress] = useState("");
  const [addressLoading,setAddressLoading] = useState(false)

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedAddress(rawAddress);
    }, 2000); // Wait 2 seconds

    return () => clearTimeout(timeout); // Clear timeout if user keeps typing
  }, [rawAddress]);

  useEffect(() => {
    if (debouncedAddress || debouncedAddress === '') {
      // Set the form state here or make your API call
      setCreateLeadForm((prev) => ({ ...prev, address: debouncedAddress }));
      // You can also call your API here if needed
    }
  }, [debouncedAddress]);

  const handleCheckboxChange = (campaign) => {
    setCreateLeadForm((prev) => ({
      ...prev, // Preserve the existing form state
      excludeCampaign: prev.excludeCampaign.includes(campaign)
        ? prev.excludeCampaign.filter((c) => c !== campaign) // Remove if unchecked
        : [...prev.excludeCampaign, campaign] // Add if checked
    }));
  };


  useEffect(() => {
    leadInsight()
  }, [CreateLeadForm.state, CreateLeadForm.taluka, CreateLeadForm.district, CreateLeadForm.target, CreateLeadForm.address])


  const getStatesFunc = async () => {
    try {
      setStatesLoading(true)
      setStateDistrict([])
      setTalukas([])
      const states = await getStates()
      setIndianStates(states?.records)
      setStatesLoading(false)
    } catch (err) {
      setStatesLoading(false)
      console.log(err);
      Popup.alert("Error", err.errorMessage, "ERROR");
    }
  }

  const getDistrictFunc = async (stateCode, stateName) => {
    try {
      setDistrictsLoading(true)
      setTalukas([])
      const districts = await getDistricts(stateCode, stateName)
      setStateDistrict(districts?.records)
      setDistrictsLoading(false)
    } catch (err) {
      setDistrictsLoading(false)
      console.log(err);
      Popup.alert("Error", err.errorMessage, "ERROR");
    }
  }

  const getTalukasFunc = async (districtCode, districtName) => {
    try {
      setTalukasLoading(true)
      const talukas = await getTalukas(districtCode, districtName)
      setTalukas(talukas?.records)
      setTalukasLoading(false)
    } catch (err) {
      setTalukasLoading(false)
      console.log(err);
      Popup.alert("Error", err.errorMessage, "ERROR");
    }
  }

  const getAllTeleCaller = async () => {
    getTelecallerTeamswithCount(
      "Telecaller Sales",
      "/bhumeet_team/admin/manage_team/telecallerteam"
    ).then((res) => {
      let filteredData = res.TeleCallerTeam.map((x) => {
        let count = res.getCount.find(c => c.id === x.id)?.call_queue_count || 0;
        return { label: `${x.name} - Workload(${count})`, value: x.id };
      });
      setTelecallerDeskCallers(filteredData);
    });
  };


  const leadInsight = async () => {
    try {
      setAddressLoading(true)
      let insight = await getCrmleadsInsight({
        ...CreateLeadForm,
        district: CreateLeadForm.district?.value !== "All" ? CreateLeadForm.district : { label: CreateLeadForm.district?.label, value: undefined },
        taluka: CreateLeadForm.taluka?.value !== "All" ? CreateLeadForm.taluka : { label: CreateLeadForm.taluka?.label, value: undefined },
      });
      setAddressLoading(false)
      if (insight?.leads) {
        setCampaignName(insight?.leads?.campaigndetail)
        // setCreateLeadForm((prev)=>({...prev,excludeCampaign:insight?.leads?.campaigndetail?.map((c)=>c.campaign_id)}))
      }
      if (insight.leads && insight?.leads?.state_assigned_call_queue && insight?.leads?.state_count && insight?.leads?.state_unassigned_call_queue) {

        setstateInsight({
          assigned_lead: insight?.leads?.state_assigned_call_queue,
          total_lead: insight.leads.state_count,
          unassigned: insight.leads.state_unassigned_call_queue
        })
      }
      if (insight.leads && insight?.leads?.district_assigned_call_queue && insight?.leads?.district_count && insight?.leads?.district_unassigned_call_queue) {

        setstateInsight({
          assigned_lead: insight?.leads?.district_assigned_call_queue,
          total_lead: insight.leads.district_count,
          unassigned: insight.leads.district_unassigned_call_queue
        })


      }

      if (insight.leads && insight?.leads?.taluka_assigned_call_queue && insight?.leads?.taluka_count && insight?.leads?.taluka_unassigned_call_queue) {

        setstateInsight({
          assigned_lead: insight?.leads?.taluka_assigned_call_queue,
          total_lead: insight.leads.taluka_count,
          unassigned: insight.leads.taluka_unassigned_call_queue
        })

      }

      if (insight.leads && insight?.leads?.address_assigned_call_queue && insight?.leads?.address_count && insight?.leads?.address_unassigned_call_queue) {

        setstateInsight({
          assigned_lead: insight?.leads?.address_assigned_call_queue,
          total_lead: insight.leads.address_count,
          unassigned: insight.leads.address_unassigned_call_queue
        })

      }
    } catch (err) {
      setAddressLoading(false)
      return Popup.alert("ERROR", "Something went wrong while fetching Insight.", 'ERROR')
    }
  }

  // FieldInfo Component
  const FieldInfo = ({ label, value, showCheckbox = false, checked, onChange }) => {
    return (
      <div className="flex items-center gap-2">
        {showCheckbox && (
          <input type="checkbox" className="mr-2" checked={checked} onChange={onChange} />
        )}
        <div className="flex flex-col gap-1">
          <span className="font-[600] font-manrope text-[16px]">{label}</span>
          <span className="font-manrope font-[500]" >{value || "-"}</span>
        </div>
      </div>
    );
  };



  return (
    <Modal
      header={existingCampaign?.id ? "Campaign Details" : "Create Campaign"}
      open={open}
      onClose={onClose}
      contentStyle={{ width: '870px', height: "auto", borderRadius: "10px" }}
    >
      {existingCampaign?.id ? (
        <div className="w-full px-7 py-8 mb-8 ">
          <div
            style={{
              fontFamily: "Manrope !important",
              fontSize: "16px",
            }}
            className="grid grid-cols-3 gap-x-4 gap-y-4"
          >
            <FieldInfo label="Name" value={existingCampaign?.name} />
            <FieldInfo label="Type" value={existingCampaign?.type} />
            <FieldInfo label="State" value={existingCampaign?.state} />
            <FieldInfo label="District" value={existingCampaign?.district} />
            <FieldInfo label="Taluka" value={existingCampaign?.taluka} />
            <FieldInfo label="Address" value={existingCampaign?.address} />
            <FieldInfo label="Target" value={existingCampaign?.target} />
            <FieldInfo label="Max Limit" value={existingCampaign?.maxLimit} />
            <FieldInfo label="Current Lead" value={existingCampaign?.call_queue_count} />
            <FieldInfo label="Converted Lead" value={existingCampaign?.converted_count} />
            <FieldInfo label="Status" value={existingCampaign?.status} />
            {/* <FieldInfo
              label="Assignee"
              value={
                existingCampaign?.assignee
                  ?.map((id) => {
                    const telecaller = telecallerDeskCallers.find(
                      (t) => t.value === id
                    );
                    return telecaller ? telecaller.label : null;
                  })
                  .filter(Boolean) // Remove any null values if IDs didn't match
                  .join(", ") || "-"
              }
            /> */}
            <FieldInfo
              label="Created Date"
              value={dateFormat(existingCampaign?.created, "dd/mm/yyyy")}
            />


          </div>
          <hr />
          {/* <label style={{marginTop:"5px"}}> Assignee Details</label> */}
          <TableView
            showSrNo={true}
            onStateChange={async (changedState) => {
              const { pageNumber } = changedState;
            }}
            onClickRow={(row) => {
            }}

            isLoading={false}
            loaderHeight={"500px"}
            columns={[
              { Header: "Caller Name", accessor: "name", width: "15%" },
              { Header: "Assigned Call", accessor: "count", width: "15%" },
              { Header: "Converted Call", accessor: "converted_count", width: "15%" },
              { Header: "Closed Call", accessor: "closed_count", width: "15%" }
            ]}
            data={existingCampaign?.assignee_detail}
            pageNumber={1}
          // pageSize={filter?.pageSize}
          // count={Number(campaigns[0]?.total_campaigns) || 0}
          // activities={{ onClickEdit: (lead) => { console.log(lead); setSelectedLead(lead); setOpenForm(true) }, isEdit: true }}
          />
        </div>
      ) : (

        <Form
          onSubmitForm={async (form) => {
            let finalScheduleDate = new Date(form?.scheduleTime);
            const now = new Date();

            if (finalScheduleDate < now) {
              finalScheduleDate = now;
            }

            let campaignData = {
              name: form?.name,
              type: form.source?.value,
              assignee: form?.assignee?.map((a) => a.value),
              target: form.target?.value,
              filter: {
                state: form.state?.value,
                district: form.district?.value && form.district?.value !== "All" ? form.district?.value : undefined,
                taluka: form.taluka?.value && form.taluka?.value !== "All" ? form.taluka?.value : undefined,
                maxLimit: form?.maxLimit,
              },
              Existing: form?.excludeCampaign.length == campaignName?.length ? false : true,
              excludeCampaign: form?.excludeCampaign,
              address: form?.address,
              scheduleTime:  campType === "Auto_IVR" ? formatToIST(finalScheduleDate.toISOString()) : undefined,
            };

            try {
              Loading.set(true);
              await createCampaign(campaignData);
              Popup.alert(
                "SUCCESS",
                "Campaign created successfully ",
                "SUCCESS"
              );
              onClose();
            } catch (err) {
              Popup.alert(
                "ERROR",
                err || "Something went wrong while creating campaign",
                "ERROR"
              );
            } finally {
              Loading.set(false);
            }
          }}
          initialValues={CreateLeadForm}
        >
          {(onsubmit) => (
            <>
              <div style={{ display: "flex", width: "100%" }}>
                <div style={{ width: "68%" }}>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: currentHeight < 695 ? "5px" : "10px",
                      padding: currentHeight < 695 ? "15px 20px" : "20px",
                      alignItems: "center",

                    }}
                  >
                    <InputField
                      type={"text"}
                      id={"name"}
                      placeholder={"Enter Campaign Name"}
                      label={"Name"}
                      value={CreateLeadForm.name}
                      defaultValue={CreateLeadForm.name}
                      handleChange={(data) => {
                        setCreateLeadForm((prev) => ({ ...prev, name: data }));
                      }}
                      name={"name"}
                      // containerStyle={{ top: callHistory.prevStatus == 'Completed' ? "-23px" : "-3px" }}
                      validation={campaignNameValidation}
                    />

                    <SelectField
                      name={"target"}
                      isDisabled={false}
                      label={"Target user"}
                      list={[{ label: "Lead", value: "lead" }, { label: "User", value: "user" }, { label: "To Retain", value: "To Retain" }]}
                      styles={{
                        width: "215px",
                        height: "18px",
                        fontSize: "13px",
                        margin: "0 0 0 -1px",
                      }}
                      // validation={selectFieldValidation}
                      defaultValue={CreateLeadForm.target}
                      handleChange={(state) => {
                        setCreateLeadForm((prev) => ({
                          ...prev,
                          target: state
                        }));
                      }}
                      containerStyle={{
                        width: "100%",
                        maxWidth: "100%",
                        minHeight: "80px",
                      }}
                      isSearchable={true}
                    />




                    <SelectField
                      handleChange={(selectedOption) => {
                        setCreateLeadForm((prev) => ({
                          ...prev,
                          source: {
                            label: selectedOption?.label,
                            value: selectedOption?.value,
                          },
                        }))
                        setCampType(selectedOption.value);
                      }}
                      name="source"
                      label="Campaign Type"
                      list={[{ label: "Calling", value: "Calling" }, { label: "Auto IVR", value: "Auto_IVR" }]}
                      styles={{ width: "100%", height: "18px", fontSize: "13px" }}
                      validation={selectFieldValidation}
                      value={
                        CreateLeadForm.source
                          ? CreateLeadForm.source
                          : { label: "", value: "" }
                      }
                      containerStyle={{ width: "100%", minHeight: "80px" }}
                    />


                    {CreateLeadForm.target?.value &&
                      <div>


                        <SelectField
                          name={"state"}
                          label={"State"}
                          isLoading={StatesLoading}
                          isDisabled={StatesLoading}
                          list={indianStates?.map((state) => ({
                            label: state.state_name_english,
                            value: state.state_name_english,
                          }))}
                          validation={selectFieldValidation}
                          styles={{
                            width: "215px",
                            height: "18px",
                            fontSize: "13px",
                            margin: "0 0 0 -1px",
                          }}
                          // validation={selectFieldValidation}
                          defaultValue={CreateLeadForm.state}
                          handleChange={(state) => {
                            setTalukas([]);
                            setStateDistrict([]);
                            getDistrictFunc(undefined, state?.label);
                            setCreateLeadForm((prev) => ({
                              ...prev,
                              state: state,
                              district: { label: "", value: "" },
                              taluka: { label: "", value: "" },
                            }));

                          }}
                          containerStyle={{
                            width: "100%",
                            maxWidth: "100%",
                            minHeight: "80px",
                          }}
                          isSearchable={true}
                        />



                      </div>
                    }

                    {CreateLeadForm.target?.value  &&

                      <>
                        <div>
                          <SelectField
                            name={"district"}
                            label={"District"}
                            isLoading={DistrictsLoading}
                            isDisabled={DistrictsLoading}
                            list={CreateLeadForm.state?.value ? [
                              { label: "All", value: "All" },
                              ...StateDistrict?.map((state) => ({
                                label: state.district_name_english,
                                value: state.district_name_english,
                              })),
                            ] : StateDistrict?.map((state) => ({
                              label: state.district_name_english,
                              value: state.district_name_english,
                            }))}
                            styles={{
                              width: "215px",
                              height: "18px",
                              fontSize: "13px",
                              margin: "0 0 0 -1px",
                            }}
                            // validation={selectFieldValidation}
                            handleChange={(dist) => {
                              if (dist.label === "All") {
                                setTalukas([]);
                              } else {
                                getTalukasFunc(undefined, dist?.label);
                              }
                              setCreateLeadForm((prev) => ({
                                ...prev,
                                district: dist,
                                taluka: { label: "", value: "" },
                              }));

                            }}
                            containerStyle={{
                              width: "100%",
                              maxWidth: "100%",
                              minHeight: "80px",
                            }}
                            isSearchable={true}
                          />

                        </div>

                        <div>
                          <SelectField
                            name={"taluka"}
                            isLoading={talukasLoading}
                            isDisabled={talukasLoading}
                            label={"talukas"}
                            list={CreateLeadForm.district?.value && CreateLeadForm.district?.value !== 'All' ? [
                              { label: "All", value: "All" },
                              ...talukas?.map((t) => ({
                                value: t?.subdistrict_name_english,
                                label: t?.subdistrict_name_english,
                              })),
                            ] : talukas?.map((t) => ({
                              value: t?.subdistrict_name_english,
                              label: t?.subdistrict_name_english,
                            }))}
                            styles={{
                              width: "215px",
                              height: "18px",
                              fontSize: "13px",
                              margin: "0 0 0 -1px",
                            }}
                            isSearchable={true}
                            containerStyle={{
                              width: "100%",
                              maxWidth: "100%",
                              minHeight: "80px",
                            }}
                            handleChange={(taluka) => {
                              setCreateLeadForm((prevForm) => ({
                                ...prevForm,
                                taluka: taluka,
                              }));
                            }}
                          />

                        </div>



                      </>

                    }

                    {
                      CreateLeadForm.target?.value &&
                      <div>

                        <InputField
                          type={"text"}
                          id={"address"}
                          placeholder={"Enter Address "}
                          disabled={addressLoading}
                          label={"Address"}
                          value={rawAddress}
                          handleChange={(data) => {
                            setRawAddress(data);
                          }}
                          name={"address"}
                        validation={campAddressValidation}
                        />
                      </div>
                    }

                    <InputField
                      type={"text"}
                      id={"maxLimit"}
                      placeholder={"Enter max limit "}
                      label={"MaxLimit"}
                      value={CreateLeadForm.maxLimit}
                      handleChange={(data) => {
                        // console.log("data", data);
                        setCreateLeadForm((prev) => ({ ...prev, maxLimit: data }));
                      }}
                      name={"maxLimit"}
                      validation={campaignMaxLimitValidation}
                    />

                    <MultiSelectField
                      name="assignee"
                      label="Select Assignee"
                      list={telecallerDeskCallers}
                      placeholderText="Select Assignee"
                      validation={selectFieldValidation}
                      handleChange={(selectedOptions) => {
                        setCreateLeadForm((prevForm) => ({
                          ...prevForm,
                          assignee: selectedOptions,
                        }));
                      }}
                    />
                    {campType === "Auto_IVR" && (
                      <div className="block">
                        <p style={{ fontSize: "13px", color: "rgb(59, 59, 59)", marginBottom: "6px" }}>
                          Schedule Call
                        </p>
                        <DateTimePicker
                          title=""
                          hidePrev={new Date()}
                          selectedDateTime={CreateLeadForm.scheduleTime}
                          minTime={new Date().setHours(0, 0, 0, 0)}   // start of day (12:00 AM)
                          maxTime={new Date().setHours(23, 59, 0, 0)}
                          onChange={(date) => {
                            setCreateLeadForm((prevForm) => ({
                              ...prevForm,
                              scheduleTime: formatToIST(date),
                            }));
                          }}
                          containerWidth={"144px"}
                        />
                        {/* {!CreateLeadForm.scheduleTime && (
                          <p style={{ color: "red", fontSize: "10px" }}>Required</p>
                        )} */}
                      </div>
                    )}
                    <>





                      {/* <label style={{ fontSize: "13px", display: "flex", alignItems: "center", gap: "10px" }}>
                        <input
                          type="checkbox"
                          name="dspStatus"
                          disabled={false}
                          value={CreateLeadForm.isMarked}
                          // checked={activePaymentMethods?.length === 1 && activePaymentMethods[0] === PAYMENT_METHODS.UPI}
                          onChange={(e) => {
                            console.log(e)
                            setCreateLeadForm((prev) => ({ ...prev, Existing: !CreateLeadForm.Existing }))
                          }}
                          style={{ cursor: false ? "not-allowed" : "pointer" }}
                        />
                        {"Include All"}
                      </label> */}


                    </>

                    {(stateInsight) &&

                      <>

                        <div style={{ gridColumn: "1 / -1" }}>
                          <label style={{ marginBottom: "10px" }}>Summary </label>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              gap: "10px",
                              alignContent: "center"
                            }}
                          // className="grid grid-cols-3 gap-x-4 gap-y-4"
                          >
                            <FieldInfo label="Total" value={stateInsight?.total_lead} />
                            <FieldInfo label="Assigned" value={stateInsight?.assigned_lead} />
                            <FieldInfo label="Unassigned" value={stateInsight?.unassigned} />



                          </div>
                        </div>
                      </>
                    }

                    {/* Buttons (Spanning two columns) */}
                    <div
                      style={{
                        gridColumn: "span 2", // Spanning full width
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "10px",
                        padding: currentHeight < 695 ? "10px" : "20px",
                        height: "70px",
                      }}
                    >




                      <Button
                        isDisabled={!CreateLeadForm.scheduleTime === "Auto_IVR" ? true : false}
                        text={"Add"}
                        onClick={onsubmit}
                        className="btn-large"
                      />
                      <Button
                        text="Cancel"
                        onClick={onClose}
                        className="btn-large lg-cancel-btn"
                        isBtnNotActive={true}
                      />
                    </div>


                  </div>




                </div>




                <div>
                  {(campaignName) ?

                    <div style={{width:"256px"}} className="w-full px-7 py-8 mb-8">
                      <div style={{display:"flex",justifyContent:"space-between",gap:"5px",marginBottom:"5px"}}>
                      <label style={{  }}>
                        Exclude Campaign 
                      </label>
                      

                      

                      {/* <Button
                        text={CreateLeadForm.Existing ? "All" : 'Existing'}
                        onClick={(e)=>{
                          e.preventDefault()
                          console.log(e.target.innerText)
                          setCreateLeadForm((prev) => ({ ...prev, Existing: !CreateLeadForm.Existing,excludeCampaign:CreateLeadForm.Existing ? [] : campaignName.map((c)=>c.campaign_id) }))
                        }}
                        className="btn-large"
                      /> */}

                      

                      </div>
                      <label style={{ fontSize: "13px", display: "flex", alignItems: "center", gap: "10px" }}>
                        <input
                          type="checkbox"
                          name="dspStatus"
                          disabled={false}
                          value={CreateLeadForm.isMarked}
                          // checked={activePaymentMethods?.length === 1 && activePaymentMethods[0] === PAYMENT_METHODS.UPI}
                          onChange={(e) => {
                            setCreateLeadForm((prev) => ({ ...prev, Existing: !CreateLeadForm.Existing ,excludeCampaign:e.target.checked ? campaignName.map((c)=>c.campaign_id) : []}))
                          }}
                          style={{ cursor: false ? "not-allowed" : "pointer" }}
                        />
                        {"Select All"}
                      </label>

                      <div
                        style={{
                          fontFamily: "Manrope, sans-serif",
                          fontSize: "16px",

                          maxHeight: "366px", // Set max height for scrolling
                          overflowY: "auto",  // Enable vertical scroll
                        }}
                      // className="grid grid-cols-3 gap-x-4 gap-y-4"
                      >
                        {campaignName.map((item, index) => (
                          <>
                            <FieldInfo
                              key={item.campaign_id}
                              label={item.CampaignName}
                              value={`${item.leadCount}`}
                              showCheckbox
                              checked={CreateLeadForm.excludeCampaign.includes(item.campaign_id)}
                              onChange={(e) => handleCheckboxChange(item.campaign_id)}
                            />
                            <hr />

                          </>
                        ))}
                      </div>
                    </div>


                    : <div className="w-full px-7 py-8 mb-8">
                      <label style={{ marginBottom: "10px", display: "block", whiteSpace: "nowrap" }}>
                        No Campaign
                      </label>
                    </div>}
                </div>
              </div>

            </>

          )}
        </Form>


      )}
    </Modal>
  );
};
